import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";

export function useAttendancesHistory(userId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["attendances", "history", userId],
		queryFn: async () => {
			const response = await client.users[":userId"].attendances.history.$get({
				param: { userId },
			});
			const data = await responseHandler(response);
			return guardArray(data.history);
		},
	});

	return { ...query, history: guardArray(query.data) };
}
